import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AppRoutes from './routes';
import CustomTextField from './components/CustomTextField';

// RTL Cache
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

// Theme
const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: 'Vazirmatn, sans-serif',
    fontSize: 14,
  },
  palette: {
    primary: { main: '#1976d2' },
    secondary: { main: '#ff9800' },
    background: { default: '#f5f5f5' },
  },
  components: {
    MuiButton: { styleOverrides: { root: { borderRadius: 8 } } },
    MuiCard: { styleOverrides: { root: { borderRadius: 12 } } },
    MuiTextField: { defaultProps: { variant: 'outlined', size: 'small', fullWidth: true } },
    MuiInputBase: {
      styleOverrides: {
        root: {
          // برای input های عددی، direction رو LTR می‌کنیم
          '&:has(input[type="number"])': {
            direction: 'ltr !important',
          },
          '&:has(input[type="tel"])': {
            direction: 'ltr !important',
          },
        },
        input: {
          // خود input عددی هم LTR
          '&[type="number"]': {
            direction: 'ltr !important',
            textAlign: 'left !important',
          },
          '&[type="tel"]': {
            direction: 'ltr !important',
            textAlign: 'left !important',
          },
        },
      },
    },
  },
});

function App() {
  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer position="top-center" autoClose={3000} rtl={true} theme="colored" />
        <Router>
          <AppRoutes />
        </Router>
      </ThemeProvider>
    </CacheProvider>
  );
}

export default App;